module.exports = __webpack_public_path__ + "static/media/glass.7ecf8a4b.jpg";